module.exports = __webpack_public_path__ + "img/hd_logo_pc.6df75e2f.png";